import { set } from 'date-fns';

import { formatDate } from 'lib/helpers/dateUtils';
import { optionify } from 'lib/helpers/utility';

export default function getHours() {
  const newHours = [];
  const baseDate = new Date(2000, 0, 1);

  for (let hour = 0; hour < 24; hour++) {
    newHours.push(formatDate(set(baseDate, { hours: hour, minutes: 0 }), null, 'h:mm a'));
    newHours.push(formatDate(set(baseDate, { hours: hour, minutes: 30 }), null, 'h:mm a'));
  }

  return optionify(newHours);
}
